import { Action, createReducer, on } from '@ngrx/store';
import { TokenState } from '@shared/utils/interfaces/token.interface';
import { salvarDadosToken } from '../actions/token.actions';

const initialToken: TokenState = {
  dadosToken: null,
};

const reducer = createReducer(
  initialToken,
  on(salvarDadosToken, (state, { dadosToken }) => {
    return { ...state, dadosToken };
  })
);

export function TokenReducer(state: TokenState, action: Action) {
  return reducer(state, action);
}
